<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<script setup>
import { useQuasar } from "quasar";

const $q = useQuasar();

console.log("Quasar version:", $q.version);
</script>
